import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    textfield: {
      paddingTop: 16,
      "& > *": {
        textAlign: "left",
      },
    },
    welcomeText: {
      ...theme.fonts.h4,
      paddingTop: 104,
    },
    createAccountText: {
      ...theme.fonts.p1,
      color: theme.colors.textSubtle,
      paddingTop: 8,
    },
    submitButton: {
      marginTop: 16,
      width: "100%",
    },
    passwordRules: {
      ...theme.fonts.p2,
      display: "flex",
      alignItems: "start",
      flexDirection: "column",
      marginTop: "16px",
      textAlign: "left",
      fontFamily: "Red Hat Text",
    },
    terms: {
      marginTop: 24,
      marginBottom: 8,
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    errorBlock: {
      marginBottom: 8,
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    modalDetailsText: {
      padding: 0,
      marginLeft: "12px",
      textAlign: "left",
      marginTop: "8px",
      marginBottom: "16px",
    },
    termsLink: {
      marginLeft: 4,
      ...theme.fonts.p2,
    },
    root: {},
    header: {
      ...theme.fonts.h2,
    },
    containerStyle: {
      maxWidth: "1200px",
    },
    loadingContainer: {
      maxWidth: "780px",
      width: "780px",
    },
    errorContainer: {
      maxWidth: "780px",
      width: "780px",
      height: "780px",
    },
    skeletons: {
      marginTop: "5px",
    },
    error: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    errorMessage: {
      ...theme.fonts.h1,
    },
    copyButton: {
      ...theme.fonts.p1,
      position: "absolute",
      right: "60px",
      top: "15px",
    },
    linkButton: {
      marginRight: "8px",
    },
    footerButton: { float: "right" },
    errorIcon: {
      color: theme.colors.error,
      fontSize: 16,
      marginRight: 8,
    },
    activationErrorMessage: {
      fontSize: 12,
      fontFamily: "Lato",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
